import { useState } from "react";
import dynamic from "next/dynamic";

import { ContactsContext } from "~/contexts/ContactsContext";

const ContactDrawer = dynamic(
  () =>
    typeof window === "undefined"
      ? Promise.resolve(() => null)
      : // oxlint-disable-next-line remi/no-async-import -- client-only; keeps ContactDrawer (google-libphonenumber, task drawers) out of _app's chunk and every server function
        import("~/components/person/contact-drawer/ContactDrawer").then((m) => m.ContactDrawer),
  { ssr: false },
);

export const ContactDrawerWrapper = ({ children }: { children: React.ReactNode }) => {
  const [contactViewingId, setContactViewingId] = useState<string | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <ContactsContext.Provider value={{ setContactViewingId, setIsEditing }}>
      {children}
      {contactViewingId ? <ContactDrawer contactViewingId={contactViewingId} isEditing={isEditing} /> : null}
    </ContactsContext.Provider>
  );
};
